import { render, staticRenderFns } from "./busquedaRuc.vue?vue&type=template&id=23021aad&scoped=true"
import script from "./busquedaRuc.vue?vue&type=script&lang=js"
export * from "./busquedaRuc.vue?vue&type=script&lang=js"
import style0 from "./busquedaRuc.vue?vue&type=style&index=0&id=23021aad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23021aad",
  null
  
)

export default component.exports